import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import SearchableDropdown from "../../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx";
import { PaginatedResponse } from "../../../../interfaces/Management.interface";
import { ManagementActions } from "../../../../Services/_actions";
import { useSnackBar } from "../../../FlowBuilder/Common/SnackBar/index.tsx";

interface ProfileFormProps {
  setFormData: (data: any) => void;
  formData: any | null;
  errors: any | null;
}

const ProfileForm: React.FC<ProfileFormProps> = ({ formData, setFormData, errors }) => {
  console.log(errors,"errorserrors")
  // https://devapi.machadalo.com/v0/ui/website/clone-profile/ 
  const { showSnackBar } = useSnackBar();
  const actions = ManagementActions();
  const [profileResponse, setProfileResponse] = useState<PaginatedResponse>({ count: 0, list: [] });
  const [profileFilter, setProfileFilter] = useState<{ organisationId?: string, page?: number, search?: string }>({ page: 0, search: "", organisationId: "" });
  const [profileIsLoading, setProfileIsLoading] = useState(false);
  const getProfileList = async (filterObj: { organisationId?: string, page?: number, search?: string }) => {
    setProfileResponse({ ...profileResponse, list: [] });
    setProfileIsLoading(true);
    try {
      const res = await actions.getProfileList(filterObj);
      if (res?.status === 200) {
        setProfileResponse(res?.data || {});
      }
    } catch (error) {
      throw error;
    }
    setProfileIsLoading(false);
  };
  const loadMoreProfile = async () => {
    if ((profileFilter?.page || 0) < (profileResponse?.pages || 0)) {
      setProfileIsLoading(true);
      let listData: any[] = Array.isArray(profileResponse?.list) ? [...profileResponse?.list] : [];
      const data = { ...profileFilter, page: (profileFilter.page||0) + 1 };
      try {
        const res = await actions.getProfileList(data);
        if (res?.status === 200 && res?.data?.list && Array.isArray(res.data.list)) {
          listData = [...listData, ...res.data.list];
          setProfileResponse({ ...res.data, list: listData });
          setProfileFilter(data);
        } else {
          showSnackBar('Unexpected response structure or status:', 'error');
        }
      } catch (error) {
        showSnackBar('Error loading more organizations:', 'error');
      } finally {
        setProfileIsLoading(false);
      }
    }
  };

  // const handleSearchProfile = (query) => {
  //   const updatedFilter = { ...profileFilter, search: query || '', page: 0 };
  //   setProfileFilter(updatedFilter);
  //   getProfileList(updatedFilter);
  // };

  useEffect(() => {
    getProfileList(profileFilter);
  }, [])

  return (
    <Box
      sx={{
        // padding: "20px",
        // maxWidth: "900px",
        // margin: "auto",
        // backgroundColor: "#f9f9f9",
        // borderRadius: "8px",
        // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Typography
        variant="h5"
        component="h1"
        sx={{
          marginBottom: "20px",
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        Profile Form - Basic Information
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="profile Name"
            placeholder="Enter Profile Name"
            variant="outlined"
            size="small"
            value={formData?.new_name || ''}
            onChange={(e) => setFormData({ ...formData, new_name: e.target.value })}
            error={!!errors?.new_name}
            helperText={errors?.new_name}

          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <SearchableDropdown
            options={profileResponse?.list || []}
            label="Assign Profile"
            labelKey="name"
            value={formData?.selectedProfile || null}
            fetchMoreOptions={(profileFilter?.page || 0) < (profileResponse?.pages || 0) ? loadMoreProfile : undefined}
            // onSearch={handleSearchProfile}
            onChange={(profile) => setFormData({ ...formData, clone_from_profile_id: profile?.id, selectedProfile: profile })}
            loading={profileIsLoading}
            error={!!errors?.clone_from_profile_id}
            errorMessage={errors?.clone_from_profile_id}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProfileForm;
